const prefix = '@communities';

export const CommunitiesActionType = {
  GetCommunities: `${prefix}/GET_COMMUNITIES`,
  PostUserCommunityPreferences: `${prefix}/POST_USER_COMMUNITY_PREFERENCES`,
};
